import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
});

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  // Only add token for non-auth endpoints
  if (
    token &&
    !config.url.includes('/auth/request-otp/') &&
    !config.url.includes('/auth/verify-otp/')
  ) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Redirect to login only when the user had a token that is now invalid/expired.
// Do NOT redirect if the user was never logged in — that would kick anonymous
// users off public pages when a background request hits an auth-required endpoint.
instance.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      const hadToken = !!localStorage.getItem('token');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (hadToken) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
